/* eslint-disable no-param-reassign */
import { createSlice, createAction } from '@reduxjs/toolkit';

import initialState from '../../../domain/app/entities/desafios';


// ---------------- Saga's response ----------------
function fetchDesafiosSuccess(state, action) {
  const { respuestaServicio } = action.payload;
  state.response = respuestaServicio;
  state.errorFetchConfirmar = false;
}

function fetchDesafiosError(state) {
  state.response = [];
  state.errorFetchConfirmar = true;
}

function fetchDesafioSolicitarSuccess(state, action) {
  state.response = action.payload;
  state.error = false;
}

function fetchDesafioSolicitarError(state) {
  state.response = [];
  state.error = true;
}

function fetchDesafioValidarSuccess(state, action) {
  state.response = { ...state.response, tercerFactor: { ...state.response.tercerFactor, validar: action.payload }};
  state.error = false;
}

function fetchDesafioValidarError(state) {
  state.response = [];
  state.error = true;
}

const fetchDesafios = createAction('fetchDesafios');
const fetchDesafioSolicitar = createAction('fetchDesafioSolicitar');
const fetchDesafioValidar = createAction('fetchDesafioValidar');

// ------------- connection ------------- //

const desafiosReducer = createSlice({
  name: 'desafios',
  initialState,
  reducers: {
    fetchDesafiosSuccess,
    fetchDesafiosError,
    fetchDesafioSolicitarSuccess,
    fetchDesafioSolicitarError,
    fetchDesafioValidarSuccess,
    fetchDesafioValidarError
  },
});

export const desafiosAction = {
  ...desafiosReducer.actions,
  fetchDesafios,
  fetchDesafioSolicitar,
  fetchDesafioValidar
};

export default desafiosReducer.reducer;